module.exports = __webpack_public_path__ + "media/images/emblems/Trey-coat_of_arms-84fb2b6e7e874eb94bd7b46ef544daf1.svg";